/**
 * RBP: swipe hint for product sliders on mobile.
 *
 * On narrow screens the "Complete the look" and "You may also like" rows are
 * cut off at the right edge with nothing to signal they scroll. This nudges
 * them left and back, repeating until the visitor touches the row.
 *
 * Deliberately does NOT touch the Swiper instance. An earlier version called
 * translateTo(), which fought Swiper's own transform and left "Complete the
 * look" stuck. This animates the slider container with CSS instead, so
 * Swiper's state is never modified and it cannot be knocked out of sync.
 */
(function () {
  var REPEAT_MS = 4000;
  // Pulses per time the row comes into view. Repeating forever kept the
  // compositor busy on mobile; three is enough to read as a hint, and coming
  // back to the row starts a fresh set.
  var MAX_PULSES = 3;

  function reducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function isMobile() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  /** Only hint when there is actually something more to scroll to. */
  function hasOverflow(el) {
    var wrapper = el.querySelector(".swiper-wrapper");
    if (!wrapper) return false;
    return wrapper.scrollWidth > el.clientWidth + 8;
  }

  function watch(el) {
    if (el.dataset.rbpSwipeHint) return;
    el.dataset.rbpSwipeHint = "watching";

    var timer = null;
    var observer = null;

    function stop() {
      el.classList.remove("rbp-swipe-hint--run");
      if (timer) { clearInterval(timer); timer = null; }
      if (observer) { observer.disconnect(); observer = null; }
      el.dataset.rbpSwipeHint = "done";
    }

    var pulses = 0;

    function pulse() {
      if (!hasOverflow(el)) return;
      if (++pulses > MAX_PULSES) {
        if (timer) { clearInterval(timer); timer = null; }
        return;
      }
      el.classList.remove("rbp-swipe-hint--run");
      // reflow, so the animation can be retriggered
      void el.offsetWidth;
      el.classList.add("rbp-swipe-hint--run");
    }

    // Any interaction with the row ends the hint for good.
    ["pointerdown", "touchstart", "mousedown", "wheel"].forEach(function (evt) {
      el.addEventListener(evt, stop, { once: true, passive: true });
    });

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (timer) return;
            pulses = 0;
            setTimeout(pulse, 500);
            timer = setInterval(pulse, REPEAT_MS);
          } else {
            // Out of view: pause rather than stop. Coming back into view
            // restarts the hint, so it acts as a reminder each time.
            if (timer) { clearInterval(timer); timer = null; }
            el.classList.remove("rbp-swipe-hint--run");
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
  }

  function init() {
    if (!isMobile() || reducedMotion()) return;
    document.querySelectorAll(".card-product-slider").forEach(watch);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // "Complete the look" fetches its products, so its slider appears late.
  document.addEventListener("shopify:section:load", init);

  // Watch for that late slider, but only briefly and only while none has been
  // found. An earlier version observed the whole body subtree for the life of
  // the page and re-ran init() on every mutation -- measured at 80 mutation
  // batches during a few seconds of scrolling, each triggering a full
  // querySelectorAll. That is pure overhead once the sliders exist.
  if (document.body && isMobile() && !reducedMotion()) {
    var late = new MutationObserver(function () {
      init();
      if (document.querySelectorAll(".card-product-slider").length) late.disconnect();
    });
    late.observe(document.body, { childList: true, subtree: true });
    // Hard stop regardless, so nothing observes forever.
    setTimeout(function () { late.disconnect(); }, 12000);
  }
})();
